var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor create-ticket" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("section", [
        _c("div", { staticClass: "title" }, [_vm._v("Subject")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Type Ticket Subject",
                "show-attributes": true,
                "show-emoji": true,
                "max-character-count": 1024,
              },
              model: {
                value: _vm.clone.subject,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "subject", $$v)
                },
                expression: "clone.subject",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v("Visitor's Email Address"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Type visitor email address or use attribute",
                "show-attributes": true,
                "show-emoji": false,
                "max-character-count": 400,
              },
              model: {
                value: _vm.clone.visitorEmailAddress,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "visitorEmailAddress", $$v)
                },
                expression: "clone.visitorEmailAddress",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [_vm._v("Visitor's Phone Number")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Type visitor phone number or use attribute",
                "show-attributes": true,
                "show-emoji": false,
                "max-character-count": 400,
              },
              model: {
                value: _vm.clone.visitorPhoneNumber,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "visitorPhoneNumber", $$v)
                },
                expression: "clone.visitorPhoneNumber",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [_vm._v("Ticket Tag")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("a-auto-complete", {
              staticClass: "w-100",
              attrs: {
                "data-source": _vm.tagList,
                placeholder: "Select or Create a Ticket Tag",
              },
              on: {
                select: _vm.onSelect,
                search: _vm.onSearch,
                change: _vm.onChange,
              },
              model: {
                value: _vm.clone.tag,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "tag", $$v)
                },
                expression: "clone.tag",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }